import { render } from "./ProductSearch.vue?vue&type=template&id=570fca36&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"

import "./ProductSearch.vue?vue&type=style&index=0&id=570fca36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570fca36"]])

export default __exports__